module.exports = __webpack_public_path__ + "img/OverseaMember23.ba55244c.png";